export default {
	state:()=>({
		role:"user"
	}),
	mutations: {
	
	},
	actions: {},
	getters: {}
}